class MobileNav extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.body.querySelector("#shopify-section-header");
    this.cloak = document.body.querySelector(".modal-overlay");

    this.menuToggle = document.body.querySelector('.js-mobile-nav-toggle');
    this.menuDrawer = document.body.querySelector('.js-mobile-nav-drawer');
    this.menuDrawerState = {
      open: false,
    }

    this.menuToggle.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleDrawer();
    });
  }

  toggleDrawer() {
    if (this.menuDrawerState.open) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    console.log('mobile nav says honk');
    hideChatWidget();

    this.checkIsOverlay();
    document.body.classList.add('overflow-hidden-tablet');
    this.header.classList.add('nav-open');
    this.classList.add('is-open');
    this.menuToggle.classList.add('is-active');
    this.setAttribute('aria-expanded', 'true');
    this.menuDrawerState.open = true;
  }

  close() {
    document.body.classList.remove('overflow-hidden-tablet');
    this.header.classList.remove('nav-open');
    this.classList.remove('is-open');
    this.menuToggle.classList.remove('is-active');
    this.closeAllDetails();
    this.setAttribute('aria-expanded', 'false');
    this.menuDrawerState.open = false;
    showChatWidget();
  }

  closeAllDetails() {
    const details = this.querySelectorAll('details');
    details.forEach((detail) => {
      detail.removeAttribute('open');
    });
  }

  checkIsOverlay() {
    if (document.body.querySelector('omni-header').classList.contains('is-overlay')) {
      let headerHeight = document.body.querySelector('omni-header .header').offsetHeight;
      this.style.setProperty('--header-height', `${headerHeight}px`)
    }
  }
}
customElements.define("mobile-nav", MobileNav);